import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Segmented, Spin, message } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import PeakLoadChart from "../card/peakLoadChart";
import getTrafficPeak from "functions/admin/getTrafficPeak";

const PeakLoadPanel = () => {
  const [mode, setMode] = useState("last14");
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);
  const [errorText, setErrorText] = useState(null);

  const loadReport = useCallback(async () => {
    setLoading(true);
    setErrorText(null);
    try {
      const response = await getTrafficPeak(mode);
      if (!response?.success) {
        const msg =
          response?.error?.message ||
          response?.message ||
          "Тайлан ачааллахад алдаа гарлаа.";
        setErrorText(msg);
        setReport(null);
        message.error(msg);
        return;
      }
      setReport(response.data);
    } catch (e) {
      const msg = e?.message || "Тайлан ачааллахад алдаа гарлаа.";
      setErrorText(msg);
      setReport(null);
    } finally {
      setLoading(false);
    }
  }, [mode]);

  useEffect(() => {
    loadReport();
  }, [loadReport]);

  return (
    <div className="p-4 sm:p-6">
      <div className="mb-4">
        <h2 className="text-lg sm:text-xl font-bold text-[#32B7C2] m-0 flex items-center gap-2">
          <span aria-hidden>⚡</span>
          Системийн оргил цаг
        </h2>
      </div>

      {errorText && (
        <Alert
          type="warning"
          showIcon
          className="mb-4 rounded-xl"
          message="Тайлан ачааллаагүй"
          description={errorText}
        />
      )}

      <div
        className="mb-4 p-3 sm:p-4 rounded-xl bg-gray-50 border border-gray-100 flex flex-wrap gap-3 items-center"
        role="toolbar"
        aria-label="Тайлан горим"
      >
        <Segmented
          value={mode}
          onChange={setMode}
          options={[
            { label: "Сүүлийн 14 хоног", value: "last14" },
            { label: "Өмнөх 1 өдөр", value: "yesterday" },
          ]}
        />
        <Button
          icon={<ReloadOutlined />}
          onClick={loadReport}
          loading={loading}
        >
          Шинэчлэх
        </Button>
      </div>

      <Spin spinning={loading}>
        <PeakLoadChart report={report} mode={mode} />
      </Spin>
    </div>
  );
};

export default PeakLoadPanel;
